import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-member-reference',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterLink],
  templateUrl: './member-reference.component.html',
  styleUrl: './member-reference.component.scss',
})
export class MemberReferenceComponent {
  @Input({ required: true }) name = '';
  @Input() personId: string | null | undefined;
  @Input() isDeceased = false;
  @Input() stopPropagation = false;

  onClick(event: MouseEvent): void {
    if (this.stopPropagation) {
      event.stopPropagation();
    }
  }
}
